// src/authConfig.js
// Microsoft Authentication Library (MSAL) configuration for Azure AD SSO

export const msalConfig = {
    auth: {
        // Your Azure AD Application (client) ID
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'a3655097-379f-415b-a3c3-343349db4b99',
        
        // Your Azure AD Tenant ID - this restricts login to your organisation only
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || '6f9d1d6e-fc78-4b45-a810-34d6e0aed5e4'}`,
        
        // Where to redirect after login
        redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
        
        // Where to redirect after logout
        postLogoutRedirectUri: window.location.origin,
        
        // Required for single-page apps
        navigateToLoginRequestUrl: true,
    },
    cache: {
        // Persist login across tabs and browser restarts; cleared on explicit sign-out
        cacheLocation: 'localStorage',
        
        // Recommended for security
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                switch (level) {
                    case 0: // Error
                        console.error('[MSAL]', message);
                        break;
                    case 1: // Warning
                        console.warn('[MSAL]', message);
                        break;
                    case 2: // Info
                        console.info('[MSAL]', message);
                        break;
                    case 3: // Verbose
                        console.debug('[MSAL]', message);
                        break;
                    default:
                        break;
                }
            },
            logLevel: 1, // Warning level - change to 3 for verbose debugging
        },
    },
};

// Scopes for the ID token (what info we want about the user)
export const loginRequest = {
    scopes: ['User.Read', 'openid', 'profile', 'email'],
};

// Scopes for Microsoft Graph API calls (if you need them later)
export const graphConfig = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
